webpackJsonp([5239569149700],{

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(39);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(24);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(33);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(32);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Message3 = __webpack_require__(70);
	
	var _Message4 = _interopRequireDefault(_Message3);
	
	var _Image3 = __webpack_require__(73);
	
	var _Image4 = _interopRequireDefault(_Image3);
	
	var _Header3 = __webpack_require__(29);
	
	var _Header4 = _interopRequireDefault(_Header3);
	
	var _Container3 = __webpack_require__(26);
	
	var _Container4 = _interopRequireDefault(_Container3);
	
	var _Form3 = __webpack_require__(43);
	
	var _Form4 = _interopRequireDefault(_Form3);
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _mobxReact = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferralsPage = (_dec = (0, _mobxReact.inject)('UserStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_React$Component) {
	  (0, _inherits3.default)(ReferralsPage, _React$Component);
	
	  function ReferralsPage() {
	    (0, _classCallCheck3.default)(this, ReferralsPage);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ReferralsPage.prototype.render = function render() {
	    var _props$UserStore = this.props.UserStore,
	        handleChange = _props$UserStore.handleChange,
	        issueReferralCode = _props$UserStore.issueReferralCode;
	    var _props$UserStore2 = this.props.UserStore,
	        _issuedReferralCode = _props$UserStore2._issuedReferralCode,
	        loading = _props$UserStore2.loading;
	
	    return _react2.default.createElement(
	      _Container4.default,
	      { text: true, textAlign: 'left' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          '\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0439 \u0434\u0440\u0443\u0437\u044C\u044F\u043C \u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0439 \u0411\u0415\u0421\u041F\u041B\u0410\u0422\u041D\u042B\u0415 \u0431\u0438\u043B\u0435\u0442\u044B - Fake Flight Tickets'
	        ),
	        _react2.default.createElement('meta', { name: 'twitter:title', content: '\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0439 \u0434\u0440\u0443\u0437\u044C\u044F\u043C \u0438 \u043F\u043E\u043B\u0443\u0447\u0438 \u0441\u043A\u0438\u0434\u043A\u0438 - Fake Flight Tickets' }),
	        _react2.default.createElement('meta', { name: 'twitter:image', content: '/opengraph-image.ru.jpg' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: '/opengraph-image.ru.jpg' })
	      ),
	      _react2.default.createElement(
	        _Header4.default,
	        { as: 'h1' },
	        '\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0439 \u0434\u0440\u0443\u0437\u044C\u044F\u043C \u2014',
	        _react2.default.createElement('br', null),
	        ' \u043F\u043E\u043B\u0443\u0447\u0430\u0439 \u0411\u0415\u0421\u041F\u041B\u0410\u0422\u041D\u042B\u0415 \u0431\u0438\u043B\u0435\u0442\u044B!'
	      ),
	      _react2.default.createElement(_Image4.default, { src: 'https://jvcorp-wpengine.netdna-ssl.com/wp-content/uploads/2014/06/AndyDwyerSmall-1.gif', rounded: true }),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u041A\u0430\u0436\u0434\u044B\u0439 \u0440\u0430\u0437 \u043A\u043E\u0433\u0434\u0430 3 \u0434\u0440\u0443\u0433\u0430 \u043F\u043E\u043A\u0443\u043F\u0430\u044E\u0442 \u0447\u0435\u0440\u0435\u0437 \u0442\u0432\u043E\u044E \u0441\u0441\u044B\u043B\u043A\u0443,',
	        _react2.default.createElement('br', null),
	        '\u0442\u044B \u0437\u0430\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0448\u044C \u0411\u0415\u0421\u041F\u041B\u0410\u0422\u041D\u042B\u0419 \u0431\u0438\u043B\u0435\u0442.',
	        _react2.default.createElement('br', null),
	        '\u041F\u043E\u0434\u0435\u043B\u0438\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0441\u044B\u043B\u043A\u043E\u0439 \u043D\u0430 \u0441\u043E\u0446 \u043C\u0435\u0434\u0438\u044F, \u0433\u0440\u0443\u043F\u043F\u0430\u0445 \u0438 \u0432 \u0441\u0432\u043E\u0451\u043C \u0431\u043B\u043E\u0433\u0435'
	      ),
	      _react2.default.createElement(
	        _Form4.default,
	        null,
	        _react2.default.createElement(
	          _Form4.default.Group,
	          { inline: true },
	          _react2.default.createElement(_Form4.default.Input, { name: 'firstName', placeholder: '\u0422\u0432\u043E\u0451 \u0438\u043C\u044F', onChange: handleChange }),
	          _react2.default.createElement(_Form4.default.Input, { name: 'email', placeholder: '\u0442\u0432\u043E\u0439@mail.ru', onChange: handleChange }),
	          _react2.default.createElement(_Form4.default.Button, (0, _extends3.default)({ content: '\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u0434', color: 'green', onClick: issueReferralCode }, { loading: loading }))
	        )
	      ),
	      _issuedReferralCode && _react2.default.createElement(_Message4.default, { icon: 'check', header: '\u041F\u0440\u043E\u0432\u0435\u0440\u044C \u0441\u0432\u043E\u0439 \u0438\u043C\u044D\u0439\u043B', content: 'Your referral link is on the way!', positive: true })
	    );
	  };
	
	  return ReferralsPage;
	}(_react2.default.Component)) || _class) || _class);
	exports.default = ReferralsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-referrals-ru-js-a37153db1b8a5cf97d14.js